import style from "./style.module.css";
import {
  TiStarOutline,
  TiStarHalfOutline,
  TiStarFullOutline,
} from "react-icons/ti";

type Props = {
  rate: number;
};

const StarNewMeta = ({ rate }: Props) => {
  const renderStar = (min: number, max: number, className: string) => {
    let result;

    if (rate > min && rate <= max) {
      result = <TiStarHalfOutline className={`text-yellow-300 ${className}`} />;
    } else {
      if (max <= rate) {
        result = (
          <TiStarFullOutline className={`text-yellow-300 ${className}`} />
        );
      } else {
        result = <TiStarOutline className={`text-gray-300 ${className}`} />;
      }
    }

    return result;
  };

  return (
    <div className={style.container}>
      {renderStar(0.2, 0.8, style.item1)}
      {renderStar(1.2, 1.8, style.item2)}
      {renderStar(2.2, 2.8, style.item3)}
      {renderStar(3.2, 3.8, style.item4)}
      {renderStar(4.2, 4.8, style.item5)}
    </div>
  );
};

export default StarNewMeta;
